import { PlasticsShipmentShippingMethod } from '../enums/plastics-shipment-shipping-method.enum';
import { FreightCarrier } from '../models/freight-carrier.model';
import { PlasticsShipment } from '../models/plastics-shipment.model';

export interface ResolvedShipmentCarrier {
    name: string;
    imageUrl: string;
    /** Carrier website / portal when the carrier record has one, else ''. */
    websiteUrl: string;
}

/** Resolves the display carrier for a shipment — the ONE place the carrier rules
 *  live, so every page (view/status/scanner/order rows) and the printed label
 *  name agree:
 *  - carrierId matches a carrier → that carrier.
 *  - Ground with no match (legacy data, or no isUpsGround carrier existed at save
 *    time) → still "UPS": ground is locked to the UPS integration by definition,
 *    so it must never read as "Best Way". Uses the isUpsGround carrier's
 *    name/image when one exists.
 *  - Anything else (blank/unmatched id on a truck shipment) → the "Best Way"
 *    default, no image. */
export function resolveShipmentCarrier(
    shipment: Pick<PlasticsShipment, 'carrierId' | 'shippingMethod'>,
    carriers: FreightCarrier[],
): ResolvedShipmentCarrier {
    const carrier = carriers.find(c => c.id === shipment.carrierId);
    if (carrier) return { name: carrier.name, imageUrl: carrier.imageUrl, websiteUrl: carrier.websiteUrl || '' };
    if (shipment.shippingMethod === PlasticsShipmentShippingMethod.Ground) {
        const upsCarrier = carriers.find(c => c.isUpsGround);
        return { name: upsCarrier?.name || 'UPS', imageUrl: upsCarrier?.imageUrl || '', websiteUrl: upsCarrier?.websiteUrl || '' };
    }
    return { name: 'Best Way', imageUrl: '', websiteUrl: '' };
}
